/**
 * Клиентский конфиг инстанса grasias.
 *
 * Единственный источник истины: какие клиентские bootstrap-ы попадут в
 * фронт-бандл и будут вызваны при инициализации AppRuntime. Vite собирает
 * только те модули, которые здесь импортированы.
 */
import { defineApp } from '@ayocore/platform/client/defineApp';

import { setup as core } from '@ayocore/platform/core/client/bootstrap';
import { setup as identity } from '@ayocore/platform/identity/client/bootstrap';
import { setup as apiGateway } from '@ayocore/platform/api-gateway/client/bootstrap';
import { setup as oauth } from '@ayocore/oauth/client/bootstrap';
import { setup as filemanager } from '@ayocore/platform/filemanager/client/bootstrap';
import { setup as messaging } from '@ayocore/platform/messaging/client/bootstrap';
import { setup as notifications } from '@ayocore/platform/notifications/client/bootstrap';
import { setup as comments } from '@ayocore/comments/client/bootstrap';
import { setup as tasks } from '@ayocore/tasks/client/bootstrap';
import { setup as catalog } from '@ayocore/catalog/client/bootstrap';
import { setup as llm } from '@ayocore/llm/client/bootstrap';
import { setup as mailer } from '@ayocore/mailer/client/bootstrap';
import { setup as telegram } from '@ayocore/telegram/client/bootstrap';
import { setup as activity } from '@ayocore/activity/client/bootstrap';
import { setup as crm } from '@ayocore/erp/crm/client/bootstrap';
import { setup as accounting } from '@ayocore/erp/accounting/client/bootstrap';
import { setup as procurement } from '@ayocore/erp/procurement/client/bootstrap';

import { setup as grasiasSelf } from './client/bootstrap';

export default defineApp({
  modules: [
    core,
    identity,
    apiGateway,
    oauth,
    filemanager,
    messaging,
    notifications,
    comments,
    tasks,
    catalog,
    llm,
    mailer,
    telegram,
    activity,
    crm,
    accounting,
    procurement,
    grasiasSelf,
  ],
});
